import { render, staticRenderFns } from "./WeekEdit.vue?vue&type=template&id=d643fff4"
import script from "./WeekEdit.vue?vue&type=script&lang=js"
export * from "./WeekEdit.vue?vue&type=script&lang=js"
import style0 from "./WeekEdit.vue?vue&type=style&index=0&id=d643fff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports